<template>
    <el-table :data="tableData" stripe style="width: 100%" :cell-style="{'text-align':'center'}">
        <el-table-column prop="openNum" label="期号" align="center" width="94">
        </el-table-column>
        <el-table-column prop="openTime" label="时间" align="center">
            <template slot-scope="scope">
                {{ getTime(scope.row.openTime) }}
            </template>
        </el-table-column>
        <el-table-column prop="result" label="开奖" align="center">
            <template slot-scope="scope">
                <template v-if="getResult(scope.row.result,0)===''">
                        --
                </template>
                <template v-else>
                    <div  class="openprize">
                        <div >{{ getResult(scope.row.result,0) }}</div>
                        <div class="ml5s"><span>+</span></div>
                        <div >{{ getResult(scope.row.result,1) }}</div>
                        <div class="ml5s"><span>+</span></div>
                        <div >{{ getResult(scope.row.result,2) }}</div>
                        <div class="ml5s"><span>=</span></div>
                        <div :class="getColor(getResult(scope.row.result,3))==1?'greenc':getColor(getResult(scope.row.result,3))==2?'redc':getColor(getResult(scope.row.result,3))==3?'bluec':''" >{{ getResult(scope.row.result,3) }}</div>
                    </div>
                </template>
            </template>
        </el-table-column>
        <el-table-column prop="num" label="预测" align="center">
            <template slot-scope="scope">
                <span v-if="!getResult(scope.row.result,3)" style="background-color: #F56C6C;"  class="resu">{{ getAllGuessValue(scope.row.guess1) }}</span>
                <span v-else>{{ getAllGuessValue(scope.row.guess1) }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="num" label="结果" align="center">
            <template slot-scope="scope">
                <template v-if="getResult(scope.row.result,3) ==''">
                    <span style="background-color: #409EFF;" class="resu" >刷新</span>
                </template>
                <template v-else-if="getGuessResult(scope.row) ==1">
                    <span style="background-color: #F56C6C;" class="resu">大小</span>
                </template>
                <template v-else-if="getGuessResult(scope.row) ==2">
                    <span style="background-color: #F56C6C;" class="resu">单双</span>
                </template>
                <template v-else-if="getGuessResult(scope.row) ==3">
                    <span style="background-color: #F56C6C;" class="resu">组合</span>
                </template>
                <template v-else-if="getGuessResult(scope.row) ==4">
                    <span style="background-color: #67C23A;" class="resu">输了</span>
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: {
        tableData: {
            type: Array,
            default: null,
            require: true
        }
    },
    methods: {
        getColor(getsum){
            let a= getsum.toString().padStart(2, '0');
            const array1 = ['00', '06', '05', '11', '16', '17', '21', '22'];
            const array2 = ['01', '02', '07', '08', '12', '13', '18', '19', '23', '24'];
            const array3 = ['03', '04', '09', '10', '14', '15', '20', '25', '26', '27'];
            if (array1.includes(a)) {
                return 1;
            } else if (array2.includes(a)) {
                return 2;
            } else if (array3.includes(a)) {
                return 3;
            } else {
                return 4;
            }
        },
        getResult(data,indx){
            if (data && data.length == 3) {
                switch (indx) {
                    case 0: {
                        return Number(data[0]);
                    }
                    case 1: {
                        return Number(data[1]);
                    }
                    case 2: {
                        return Number(data[2]);
                    }
                    case 3: {
                        let sum= Number(data[0]) + Number(data[1]) + Number(data[2]);
                        return  sum.toString().padStart(2, '0');
                    }
                }
            }
            return ""
        },
        getTime(time){
           return time.slice(11,19)
        },
        getSizeValue(data) {
            let guessData = ""
            switch (data[0]) {
                case 0: {
                    guessData += "大"
                    break
                }
                case 1:
                    {
                        guessData += "小"
                        break
                    }
            }
            return guessData
        },
        getGuessValue(data) {
            let guessData = ""
            switch (data[1]) {
                case 0: {
                    guessData += "单"
                    break
                }
                case 1:
                    {
                        guessData += "双"
                        break
                    }
            }
            return guessData
        },
        getAllGuessValue(data) {
            let guessData = ""
            switch (data[0]) {
                case 0: {
                    guessData += "大"
                    break
                }
                case 1:
                    {
                        guessData += "小"
                        break
                    }
            }
            switch (data[1]) {
                case 0: {
                    guessData += "单"
                    break
                }
                case 1:
                    {
                        guessData += "双"
                        break
                    }
            }
            return guessData

        },
        getGuessResult(data) {
            let result = this.getResult(data.result,3);
            let sizeforecast= this.getSizeValue(data.guess1);
            let oddevenforecast= this.getGuessValue(data.guess1);
            let sizeflag = false;
            let oddevenflag = false;
            if(result>=14 && sizeforecast==='大' || result<=13 && sizeforecast==='小'){
                sizeflag = true;
            }
            if(result%2==1 && oddevenforecast==='单' || result%2==0 && oddevenforecast==='双'){
                oddevenflag = true;
            }
            if(sizeflag && !oddevenflag){
                return 1;
            }else if(!sizeflag && oddevenflag){
                return 2;
            }else if(sizeflag && oddevenflag){
                return 3;
            }else{
                return 4;
            }
        },
        isBigNum(data) {

            if (data.sumResult >= 14) return true
            return false
        },
        isOddNumber(data) {
            if (data.sumResult == 0 || (data.sumResult % 2 == 0)) return false

            return true
        },
        isVerySmall(data) {
            if (data.sumResult <= 5) return true
            return false
        },
        isVersyBig(data) {
            if (data.sumResult >= 23) return true
            return false
        },
    }
}
</script>